export default "__VITE_ASSET__Dw_5JIVL__"